import { PipeTransform, Pipe } from '@angular/core';
import { UserGroupService } from "../services/user-group.service";
import { Observable } from "rxjs/Observable";

@Pipe({name: 'objectify'})
export class ObjectifyPipe implements PipeTransform {
  
  
  constructor(private userGroupService: UserGroupService) {
  }

  
  transform(iris: any): Promise<any> {
    
    if(iris===null || iris===undefined || iris==='') {
      return null;
    }
    
    if(typeof iris === 'string') {      

      return new Promise<any>((resolve) => {        
        this.transformIriToObjectPromise(iris).then((object: any) => {
          resolve(object);
        });        
      });            
    }
    else if(typeof iris === 'object') {

      return new Promise<any[]>((resolve) => {

        let objects: any[] = [];
        let objectPromises: Promise<any>[] = [];

        for (let iri of iris) {
          let objectPromise = this.transformIriToObjectPromise(iri);
          objectPromises.push(objectPromise);
          objectPromise.then((object: any) => {
            objects.push(object);
          });
        }
        Promise.all(objectPromises).then(() => {
          resolve(objects);
        });
       
      });

    }
  }
  
  
  
  private transformIriToObjectPromise(iri: string): Promise<any> {
    const objectType = iri.split("/")[1];
    let objectPromise;
    
    switch(objectType) {
      case "user_groups":
        objectPromise = this.userGroupService.getAsync(iri);
        break;
    }
    return objectPromise;
  }
  
}



// WEBPACK FOOTER //
// ./src/pipes/objectify.ts